module.exports = __webpack_public_path__ + "img/m-icon8.90c924c2.png";